var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2130_12399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.804688 2.47754C0.804688 1.37297 1.70012 0.477539 2.80469 0.477539H38.8047C39.9093 0.477539 40.8047 1.37297 40.8047 2.47754V30.4775C40.8047 31.5821 39.9093 32.4775 38.8047 32.4775H2.80469C1.70012 32.4775 0.804688 31.5821 0.804688 30.4775V2.47754Z",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80469 0.977539H38.8047C39.6331 0.977539 40.3047 1.64911 40.3047 2.47754V30.4775C40.3047 31.306 39.6331 31.9775 38.8047 31.9775H2.80469C1.97626 31.9775 1.30469 31.306 1.30469 30.4775V2.47754C1.30469 1.64911 1.97626 0.977539 2.80469 0.977539Z",
    stroke: "#1890FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_12399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4607 15.488H29.149C29.2562 15.488 29.3438 15.4003 29.3438 15.2932V13.9295C29.3438 13.8224 29.2562 13.7347 29.149 13.7347H17.4607C17.3536 13.7347 17.2659 13.8224 17.2659 13.9295V15.2932C17.2659 15.4003 17.3536 15.488 17.4607 15.488ZM17.2659 20.4555C17.2659 20.5627 17.3536 20.6503 17.4607 20.6503H29.149C29.2562 20.6503 29.3438 20.5627 29.3438 20.4555V19.0919C29.3438 18.9847 29.2562 18.8971 29.149 18.8971H17.4607C17.3536 18.8971 17.2659 18.9847 17.2659 19.0919V20.4555ZM29.5386 8.62109H10.4477C10.3406 8.62109 10.2529 8.70876 10.2529 8.8159V10.1795C10.2529 10.2867 10.3406 10.3743 10.4477 10.3743H29.5386C29.6458 10.3743 29.7335 10.2867 29.7335 10.1795V8.8159C29.7335 8.70876 29.6458 8.62109 29.5386 8.62109ZM29.5386 24.0107H10.4477C10.3406 24.0107 10.2529 24.0984 10.2529 24.2055V25.5691C10.2529 25.6763 10.3406 25.764 10.4477 25.764H29.5386C29.6458 25.764 29.7335 25.6763 29.7335 25.5691V24.2055C29.7335 24.0984 29.6458 24.0107 29.5386 24.0107ZM10.3357 17.3605L14.1417 20.3581C14.283 20.4701 14.4924 20.3703 14.4924 20.1901V14.195C14.4924 14.0148 14.2854 13.9149 14.1417 14.0269L10.3357 17.0245C10.3101 17.0444 10.2894 17.0699 10.2752 17.099C10.2609 17.1281 10.2535 17.1601 10.2535 17.1925C10.2535 17.2249 10.2609 17.2569 10.2752 17.286C10.2894 17.3152 10.3101 17.3406 10.3357 17.3605V17.3605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2130_12399",
    x: 0.804688,
    y: 0.477539,
    width: 40,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.043 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2130_12399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2130_12399",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_12399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 30.8047 6.47754)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFold);
export default __webpack_public_path__ + "static/media/menuFold.df7abb49a8cbf87833164b12af45b4b4.svg";
export { ForwardRef as ReactComponent };